<app-page
  [flush]="true"
  pageTitle="Moji termini"
  pageDescription="Pregledajte i upravljajte svojim terminima"
>
  <div class="mt-4">
    <app-client-appointments-table
      [userId]="userId"
      [isClientView]="true"
    ></app-client-appointments-table>
  </div>
</app-page>
